import IVscCommunityMapInfo from "../../../visualizers/IVscCommunityMapInfo";
import {ISlsOrd} from "../../../kova/slsordClient";
import styled from "@emotion/styled/macro";
import {useVisualizerSession} from "../../visualizer/VscVisualizerSession";
import CameraAdminInfo from "../../admin/CameraAdmin";
import ViewpointAdminInfo from "../../admin/ViewpointAdminInfo";
import {IModelConfig, IViewCamera, IViewpoint, IViewpointGroup} from "../../../data/IViewpoint";

// TODO figure how to make this work
const SiteSpecificInfoSection = styled.section`

    table td {
        border: 1px solid black;
    }
`

const SiteSpecificInfo : React.FC<{mapInfo:IVscCommunityMapInfo, slsOrd:ISlsOrd, modelConfig: IModelConfig}> = (props) => {
    const { mapInfo, modelConfig, slsOrd } = props;
    const vscVisualizer = useVisualizerSession();
    const viewCamera = (cameraId:string) => {
        vscVisualizer.changeCamera(cameraId);
    }
    const viewViewpoint = (viewpoint:IViewpoint) => {
        vscVisualizer.changeCameraToViewpoint(viewpoint, slsOrd.unrealId);
    }
    const unrealLot = mapInfo.lots.find(lot => lot.lotId === slsOrd.unrealId);




    const unrealVsErpProps : Record<string, string[]> = {
        "Plan": [ unrealLot?.blueprintName ?? "", slsOrd.modelId, ""]

    };


    const unrealVsErpOptions : Record<string, string[]> = {
    };


    for (const opt of unrealLot?.options ?? []) {
        const slsOrdOpt = slsOrd.options.find(o => o.selectionID === opt.optionMenu);

        let slsOrdValue = slsOrdOpt?.valueID;
        if (slsOrdOpt?.style) {
            slsOrdValue += "_" + slsOrdOpt.style;
        }
        if (slsOrdOpt?.color) {
            slsOrdValue += "_" + slsOrdOpt.color;
        }


        const tooltip = slsOrdOpt ? `Selection: ${slsOrdOpt.selectionName}\nValue: ${slsOrdOpt.valueName}\n` +
            `Style: ${slsOrdOpt.style}\n` +
            `Color: ${slsOrdOpt.color}\n` : `Option does not exist in ERP`;

        unrealVsErpOptions[opt.optionMenu] = [
            opt.selectedValue.length > 0 ? opt.selectedValue : "-",
            slsOrdValue ?? "",
            tooltip

        ];
    }


    const mergedErpProps = {...unrealVsErpProps, ...unrealVsErpOptions};

    const lotCameras = mapInfo.cameras.filter(camera => camera.cameraId.startsWith(slsOrd.unrealId));

    const allViews = modelConfig.views.flatMap(v => v.items);

    const enabledViewpoints: IViewCamera[] = allViews.filter(v => v.type === "viewpoint") as IViewCamera[];
    const enabledCameras : IViewCamera[] = (allViews.filter(v => v.type === "camera") as IViewCamera[])
        .map(c => ({...c, camera: `${slsOrd.unrealId}-${c.camera}`}));

    const viewpointGroupDefinition = modelConfig.viewpointGroupDefinition;
    return <SiteSpecificInfoSection>

        { unrealLot === undefined && <h3 style={{color:"red"}}>Lot not present in Unreal!</h3> }
        <h3>Unreal vs ERP</h3>
        <table style={{border: "1px solid black"}}>
            <tr>
                <th>Property</th>
                <th>Unreal</th>
                <th>ERP</th>
            </tr>

            { Object.keys(mergedErpProps).map(erpProp => <tr title={mergedErpProps[erpProp][2]}  style={{
                border: "1px solid black",
                backgroundColor: mergedErpProps[erpProp][0] === mergedErpProps[erpProp][1] ? "lightgreen" : "inherit"}}>

                <td>{erpProp}</td>
                <td>{mergedErpProps[erpProp][0]}</td>
                <td>{mergedErpProps[erpProp][1]}</td>
                </tr>) }
        </table>
        <h3>Cameras</h3>
       <CameraAdminInfo cameras={lotCameras} onViewCamera={viewCamera} enabledCameras={enabledCameras} />


        { viewpointGroupDefinition && <div>
        <h3>Viewpoints</h3>

        <ViewpointAdminInfo viewpointGroup={viewpointGroupDefinition} onViewViewpoint={viewViewpoint} enabledViewpoints={enabledViewpoints}/>
        </div>
        }
    </SiteSpecificInfoSection>


}
export default SiteSpecificInfo;